import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import VerifyEmailPage from '@/pages/verify-email'

const searchSchema = z.object({
  token: z.string().min(20).max(200),
})

export const Route = createFileRoute('/$lang/verify-email/')({
  validateSearch: (search) => searchSchema.parse(search),
  component: VerifyEmailRoute,
  staticData: { layout: 'public' },
})

function VerifyEmailRoute() {
  const { token } = Route.useSearch()
  return <VerifyEmailPage token={token} />
}
